module.exports = __webpack_public_path__ + "img/cat.56b9cf52.png";